import {createAuth0Client} from "@auth0/auth0-spa-js";

function callbackParameters() {
  return new URL(window.location.href).searchParams;
}

function callbackUrl() {
  const query = callbackParameters();
  return query.has("state") && (query.has("code") || query.has("error"))
    ? window.location.href : undefined;
}

// Keep the original OAuth response in memory before routing can rewrite the URL.
// Never persist or log this URL: it contains a one-time authorization code.
let entryCallbackUrl = callbackUrl();

export function getAuth0CallbackUrl() {
  return entryCallbackUrl || callbackUrl();
}

export function clearAuth0Callback() {
  entryCallbackUrl = undefined;
}

export function isAuth0Callback() {
  return Boolean(getAuth0CallbackUrl());
}

async function initAuth0Client() {
  var auth = createAuth0Client({
    domain: process.env.VUE_APP_AUTH_DOMAIN,
    clientId: process.env.VUE_APP_AUTH_CLIENT_ID,
    authorizationParams: {
      redirect_uri: window.location.origin,
    },
  });

  return auth;
}

export default initAuth0Client;
